export default {
    data() {
        return {
            moduleName: 'initialProcessSetup',
            detailPageRouteName: 'initialProcessSetupDetail',
            deviceTypeOptions: [],
            brandOptions: [],
            keysOptions: [],
            entity: {
                id: null,
                allow_language_selection: false,
                allow_pairing_by_mac_address: false,
                allow_pairing_by_pairing_code: false,
                default_pairing_screen: {},
                failed_pairing_screen: {},
                id_brand: null,
                id_device_type: null,
                languages: [],
                promo_settings: {
                    enabled: false,
                    translations: {
                        pairing_screen: {},
                        promo_screen: {},
                    }
                },
                welcome_screen_settings: {
                    enabled: false,
                    confirm_keys: [],
                    confirm_by_any_key: false,
                    translations: {},
                }
            },
            updateFields: [
                'allow_language_selection',
                'allow_pairing_by_mac_address',
                'allow_pairing_by_pairing_code',
                'default_pairing_screen',
                'failed_pairing_screen',
                'id_brand',
                'id_device_type',
                'languages',
                'promo_settings',
                'welcome_screen_settings'
            ],
            languageOptions: [
                {id: 'ces', name: this.$gettext('Čeština')},
                {id: 'eng', name: this.$gettext('Angličtina')},
                {id: 'deu', name: this.$gettext('Němčina')},
                {id: 'slk', name: this.$gettext('Slovenština')},
                {id: 'hun', name: this.$gettext('Maďarština')}
            ]
        }
    },
    methods: {
        getBrands(){
            this.brandService.getEntitiesForSelectBox({})
                .then((data) => {
                    this.brandOptions = this._.map(data.brands, function (item) {
                        return {id: item['id'], text: item['name']}
                    });
                    this.brandOptions.unshift({id: null, text: this.$gettext('Všechny')});
                });
        },
        getDeviceTypes() {
            this.deviceTypeService.getEntitiesForSelectBox({})
                .then((data) => {
                    this.deviceTypeOptions = this._.map(data.device_types, function (item) {
                        return {id: item['id'], text: item['name']}
                    });
                    this.deviceTypeOptions.unshift({id: null, text: this.$gettext('Všechny')});
                });
        },
        getSettings(){
            this.entityService.getSettings()
                .then((data)=> {
                    this.keysOptions = data['keys'];
                })
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/views/initialProcessSetup/mixins/InitialProcessSetup.js